const ExploreMode = {
    none: "None",
    embeddedViewerMode: "EmbeddedViewerMode",
    webAppViewerMode: "WebAppViewerMode"
}

export default ExploreMode;